import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@mui/material';
import { motion } from 'framer-motion';
import { connect } from 'react-redux';
import coinImage from '../../../../images/sales-stream/sales-stream-coin.svg';
import flameImage from '../../../../images/sales-stream/sales-stream-flame.svg';
import { removeSaleNotification } from '../../../../redux/actions/sale-notifications';

const ANIMATION_DURATION = 2.5;
const ICON_SIZE = '24px';

const SaleNotifications = ({ eventId, notifications, removeNotification }) => {
  const handleAnimationComplete = id => {
    removeNotification(id);
  };

  return (
    <Box height={ICON_SIZE} width={ICON_SIZE}>
      {notifications
        .filter(notification => notification.eventId === eventId)
        .map(({ id }) => (
          <Box key={id}>
            <motion.img
              // Image
              alt="flame"
              src={flameImage}
              // Animation
              initial={{
                scale: 0,
                opacity: 0,
              }}
              animate={{
                scale: [null, 1, 0.8, 1, 0.8, 1, 0.8, 1, 0],
                opacity: [null, 1, 1, 1, 1, 1, 1, 1, 0],
              }}
              style={{
                display: 'flex',
                position: 'absolute',
                height: ICON_SIZE,
                width: ICON_SIZE,
                zIndex: 1,
              }}
              transition={{
                duration: ANIMATION_DURATION,
              }}
              onAnimationComplete={() => handleAnimationComplete(id)}
            />

            <motion.img
              // Image
              alt="coin"
              src={coinImage}
              // Animation
              initial={{
                opacity: 0,
                rotateY: 0,
                scale: 0.25,
                y: 0,
              }}
              animate={{
                opacity: [null, 1, 1, 0],
                rotateY: [null, 360, 360, 720],
                scale: [null, 1, 1, 0.25],
                y: [null, -50, -50, 0],
              }}
              style={{
                display: 'flex',
                position: 'absolute',
                height: ICON_SIZE,
                width: ICON_SIZE,
              }}
              transition={{
                delay: ANIMATION_DURATION * 0.05,
                duration: ANIMATION_DURATION * 0.9,
              }}
            />
          </Box>
        ))}
    </Box>
  );
};

SaleNotifications.propTypes = {
  eventId: PropTypes.number.isRequired,
  notifications: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      eventId: PropTypes.number.isRequired,
    })
  ).isRequired,
  removeNotification: PropTypes.func.isRequired,
};

const mapStateToProps = state => {
  return {
    notifications: state.saleNotifications.notifications,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    removeNotification: id => dispatch(removeSaleNotification(id)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SaleNotifications);
